import {
  Box,
  CardMedia,
} from '@mui/material';
import './SortingResponse.scss';
import MediaPlayer from '../../../media/MediaPlayer';
import TextLines from '../../../text/TextLines';
import { getPageStyle } from '../../common/LessonPageUtil';

import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  responseCard: {},
  responseCardId: '',
  disablePlayMedia: false,
  onClick: () => {},
};

export default function SortingResponse(p) {
  const { responseCard, responseCardId, disablePlayMedia, onClick } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <Box
      id={responseCardId}
      boxShadow={2}
      className='sorting-response-card'
      onClick={onClick}
      style={getPageStyle(responseCard, true)}
    >
      {disablePlayMedia ? '' : (
        <MediaPlayer
          audioUrl={responseCard.audio}
          videoUrl={responseCard.video}
          parentElementId={responseCardId}
          className='response-media'
        />
      )}
      {responseCard.image ? <CardMedia image={responseCard.image} className='response-image' alt={responseCard.name} aria-label={responseCard.name} /> : ''}

      {responseCard.text ? (
        <div className='response-text'>
          <TextLines textLines={responseCard.text} />
        </div>
      ) : ''}
    </Box>
  );
}
